import script from "./VideoConsultationPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoConsultationPage.vue?vue&type=script&lang=ts&setup=true"

import "./VideoConsultationPage.vue?vue&type=style&index=0&id=64f12ce7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64f12ce7"]])

export default __exports__